import { useTranslation } from 'react-i18next';
import { AccountsFilter } from '../../Accounts';

export const AgenciesFilter = () => {
  const { t } = useTranslation();

  return <AccountsFilter keywordPlaceholder={t<string>('Search.AgencyFilterPlaceholder')} domain="agency" />;
};
